const swiperKeyFeatures = new Swiper(".key__features__slider", {
  loop: false,
  spaceBetween: 0,
  slidesPerView: "auto",
  speed: 800,
  pagination: {
    el: ".key__features__slider-pagination",
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
